import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import PublicLayout from '../../../layouts/PublicLayout';
import useSEO from '../../../seo/use-seo';
import StandardPageHelmet from '../../../seo/components/StandardPageHelmet';
import {
  VirtualCompanionshipHeroSection,
  VirtualCompanionshipExperiencesSection,
  VirtualCompanionshipWhyMembersSection,
  VirtualCompanionshipJourneyCTASection
} from './VirtualCompanionship';

const useStyles = makeStyles((theme) => ({
  pageContainer: {
    backgroundColor: '#111111',
    minHeight: '100vh',
    paddingBottom: '70px',
    color: '#ffffff',
    [theme.breakpoints.down('sm')]: {
      backgroundColor: '#0a0a0a',
    },
  },
}));

export default function VirtualCompanionshipPage() {
  const classes = useStyles();
  const seo = useSEO("login", {
    title: "Virtual Companionship | SugarCribs",
    description: "Experience genuine connection, discreet intimacy, and 1-on-1 virtual companionship with verified creators on SugarCribs."
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PublicLayout>
      <StandardPageHelmet seo={seo} />
      <div className={classes.pageContainer}>
        <VirtualCompanionshipHeroSection />
        <VirtualCompanionshipExperiencesSection />
        <VirtualCompanionshipWhyMembersSection />
        <VirtualCompanionshipJourneyCTASection />
      </div>
    </PublicLayout>
  );
}

